import { COUPON_COLORS } from '@/styles/coupon';
import { SxProps, Theme } from '@mui/material';

export const containerCouponAccountSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: {
		xs: 'column',
		md: 'row',
	},
	alignItems: {
		xs: 'flex-start',
		md: 'center',
	},
	gap: {
		xs: '16px',
		md: '24px',
	},
	padding: {
		xs: '16px',
		md: '18px 24px',
	},
	border: `1px solid ${COUPON_COLORS.border}`,
	borderRadius: '4px',
	backgroundColor: COUPON_COLORS.surface,
	color: COUPON_COLORS.text,
};

export const discountCouponAccountSX: SxProps<Theme> = {
	fontWeight: 800,
	color: 'primary.main',
	lineHeight: 1,
	whiteSpace: 'nowrap',
	fontSize: {
		xs: 'var(--font-size-display)',
		md: '56px',
	},
	'& > span': {
		fontSize: {
			xs: 'var(--font-size-lg)',
			md: 'var(--font-size-xl)',
		},
	},
};

export const textCouponAccountSX: SxProps<Theme> = {
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	gap: '4px',
};

export const labelCouponAccountSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-tiny)',
	fontWeight: 700,
	letterSpacing: '0.5px',
	textTransform: 'uppercase',
	color: COUPON_COLORS.textSecondary,
};

export const titleCouponAccountSX: SxProps<Theme> = {
	fontSize: {
		xs: 'var(--font-size-sm)',
		md: 'var(--font-size-md)',
	},
	fontWeight: 700,
	color: COUPON_COLORS.text,
};

export const detailsCouponAccountSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	lineHeight: '20px',
	color: COUPON_COLORS.textSecondary,
	'& > strong': {
		color: COUPON_COLORS.text,
	},
};

export const productCouponAccountSX: SxProps<Theme> = {
	alignSelf: {
		xs: 'stretch',
		md: 'auto',
	},
	display: 'flex',
	alignItems: 'center',
	gap: '10px',
	padding: '8px 12px',
	border: `1px solid ${COUPON_COLORS.borderStrong}`,
	borderRadius: '4px',
	backgroundColor: '#FFF',
};

export const productImageCouponAccountSX: SxProps<Theme> = {
	flex: 'none',
	width: '52px',
	height: '52px',
	borderRadius: '4px',
	objectFit: 'cover',
};

export const productTextCouponAccountSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-caption)',
	lineHeight: 1.3,
	color: COUPON_COLORS.textSecondary,
	'& > strong': {
		color: COUPON_COLORS.text,
	},
};

export const buttonCouponAccountSX: SxProps<Theme> = {
	flex: 'none',
	width: {
		xs: '100%',
		md: 'auto',
	},
	padding: '12px 24px',
	fontSize: 'var(--font-size-default)',
	whiteSpace: 'nowrap',
};
